export default __webpack_public_path__ + "static/media/perfume_one_day_web.a26ebfe1.jpg";